import { Drawer } from "@mui/material";
import { useSelectedIdInUrl } from "hooks/useSelectedIdInUrl";
import { Suspense } from "react";

import { ManifestLineItemDetailSection } from "../ManifestLineItems/ManifestLineItemDetailSection";
import { CompareSourcesPermalink } from "./CompareSourcesDialog";
import { LineItemsDataGrid } from "./LineItemsDataGrid";
import { ManifestDetailSection, ManifestDetailSectionSkeleton } from "./ManifestDetailSection";

interface ManifestDetailsProps {
  processedManifestId: string | undefined;
  open: boolean;
  onClose: () => void;
}

export const ManifestDetails = ({ processedManifestId, open, onClose }: ManifestDetailsProps) => {
  const {
    selectedId: wasteLineUnifiedId,
    pushIdToUrl,
    popIdFromUrl,
  } = useSelectedIdInUrl("wasteLineUnifiedId");

  return (
    <>
      {/* URL-driven Compare Sources dialog (?compare=open|line:<id>|field:<name>)
          for the open manifest. Renders independently of the drawer. */}
      {processedManifestId && <CompareSourcesPermalink processedManifestId={processedManifestId} />}
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        sx={{
          "& .MuiDrawer-paper": {
            width: { xs: "80%", sm: 600, md: 800, lg: 1000 },
            boxSizing: "border-box",
          },
        }}
      >
        <Suspense fallback={<ManifestDetailSectionSkeleton />}>
          <ManifestDetailSection processedManifestId={processedManifestId} onClose={onClose}>
            {wasteLineUnifiedId ? (
              <ManifestLineItemDetailSection
                processedManifestId={processedManifestId}
                lineItemId={wasteLineUnifiedId}
                backButtonText="Back to manifest"
                onBackButtonClick={popIdFromUrl}
              />
            ) : (
              <LineItemsDataGrid
                processedManifestId={processedManifestId}
                onRowClick={pushIdToUrl}
              />
            )}
          </ManifestDetailSection>
        </Suspense>
      </Drawer>
    </>
  );
};
